import apiService from './apiService';

// ✅ UPDATED: accepts page and search params like getShiftLog
export const getOperationInstruction = async (page = 1, search = '') => {
  try {
    const params = new URLSearchParams({
      per_page: '1000',
      page: String(page),
    });

    // ✅ correct query format: filter[search]
    if (search) params.append('filter[search]', search);

    const response = await apiService.get(`/operating-instructions?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching operating-instructions:', error);
    throw error;
  }
};

export const deleteOperationInstruction = async (id: number | string) => {
  try {
    const response = await apiService.delete(`/operating-instructions/${id}`);
    return response.data; // return full API response
  } catch (error) {
    console.error('Error deleting operating-instructions:', error);
    throw error;
  }
};

export const postOperationInstruction = async (payload: {}) => {
  try {
    const response = await apiService.post(`operating-instructions`, payload);
    return response.data; // return full API response
  } catch (error) {
    console.error('Error posting operating-instructions:', error);
    throw error;
  }
};

export const postFileUpload = async (files: File[]) => {
  try {
    const formData = new FormData();

    files.forEach((file) => {
      // 👇 if backend expects multiple under "file"
      formData.append('file', file);

      // OR 👇 if backend expects array: "files[]"
      // formData.append("files[]", file);
    });

    const response = await apiService.post('fileupload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error('Error uploading files:', error);
    throw error;
  }
};

export const getOperationInstructionByID = async (id: number | string) => {
  try {
    const response = await apiService.get(`/operating-instructions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching operating-instructions by Id:', error);
    throw error;
  }
};

export const deleteOperationInstructionByID = async (id: number | string) => {
  try {
    const response = await apiService.delete(`/operating-instructions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting operating-instructions by Id:', error);
    throw error;
  }
};

export const updateOperationInstructionByID = async (id: number | string, payload: any) => {
  try {
    const response = await apiService.put(`/operating-instructions/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating operating-instructions by Id:', error);
    throw error;
  }
};
export const notifyCheck = async (id: number | string, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/operating-instructions/${id}/notify-check`, payload);

    return response.data;
  } catch (error) {
    console.error('Error notify-check:', error);
    throw error;
  }
};

export const markChecked = async (id: number | string) => {
  try {
    const response = await apiService.post(`/operating-instructions/${id}/mark-checked`, {});

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const notifyAuthorize = async (id: number | string, payload: { user_ids: number[] }) => {
  try {
    const response = await apiService.post(`/operating-instructions/${id}/notify-authorize`, payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const markAuthorized = async (id: number | string) => {
  try {
    const response = await apiService.post(`/operating-instructions/${id}/mark-authorized`, {});

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getTechnicalSupportOfficers = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=11');
    return response.data;
  } catch (error) {
    console.error('Error fetching TSO:', error);
    throw error;
  }
};

export const getOperationManagers = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=9');
    return response.data;
  } catch (error) {
    console.error('Error fetching Operation Managers:', error);
    throw error;
  }
};

export const getShiftSupervisors = async () => {
  try {
    const response = await apiService.get('/users?filter[user_type_id]=2');
    return response.data;
  } catch (error) {
    console.error('Error fetching Shift Supervisors:', error);
    throw error;
  }
};

export const markReceived = async (id: number | string) => {
  try {
    const response = await apiService.post(`/operating-instructions/${id}/mark-received`, {});

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const downloadOperationInstructionPdf = async (id: number | string) => {
  try {
    const response = await apiService.get(`/operating-instructions/${id}/download`, {
      responseType: 'blob',
    });

    return response.data;
  } catch (error) {
    console.error('Error downloading PDF:', error);
    throw error;
  }
};
